import { useSelector } from "react-redux";
import { OtaDrawerDataInterface } from "@src/types/ota-update";
import { RootState } from "@src/reducers/store";
import { useI18N } from "@src/language/language-context";

type UseOtaFirmwareUploadModalProps = {
  inputValues: OtaDrawerDataInterface;
};

export const useOtaFirmwareUploadModal = ({
  inputValues,
}: UseOtaFirmwareUploadModalProps) => {
  const i18n = useI18N();

  const firmwareUploadModalState = useSelector(
    (state: RootState) =>
      state.yourSlice.firmwareUploadModal.firmwareUploadModalState,
  );

  const file = inputValues?.file;

  const texts = {
    uploadingFirmwareText: i18n(
      "modules.otaFirmwareUploadModal.uploadingFirmwareText",
    ),
    descriptionStartText: i18n(
      "modules.otaFirmwareUploadModal.descriptionStartText",
    ),
    helperText: i18n("modules.otaFirmwareUploadModal.helperText"),
    uploadingFirmware: i18n("modules.otaFirmwareUploadModal.uploadingFirmware"),
    firmwareUploadFailedText: i18n(
      "modules.otaFirmwareUploadModal.firmwareUploadFailedText",
    ),
    descriptionFailedText: i18n(
      "modules.otaFirmwareUploadModal.descriptionFailedText",
    ),
    helperFailedText: i18n("modules.otaFirmwareUploadModal.helperFailedText"),
    firmwareUploadSuccessText: i18n(
      "modules.otaFirmwareUploadModal.firmwareUploadSuccessText",
    ),
    descriptionSuccessText: i18n(
      "modules.otaFirmwareUploadModal.descriptionSuccessText",
    ),
    helperSuccessText: i18n("modules.otaFirmwareUploadModal.helperSuccessText"),
    fileText: i18n("modules.otaFirmwareUploadModal.fileText"),
    sizeText: i18n("modules.otaFirmwareUploadModal.sizeText"),
  };

  return {
    file,
    texts,
    firmwareUploadModalState,
  };
};
